import React from 'react';
import { Container, Row, Col, Card } from 'react-bootstrap';
import './DashboardLoading.css';

const DashboardLoading = () => {
  return (
    <Container fluid className="dashboard-container">
      <Row>
        {/* Sidebar Skeleton */}
        <div className="col-md-3 d-none d-md-block" style={{ marginLeft: "0px", paddingLeft: "0px", marginBottom: "0px", paddingBottom: "0px" }}>
          <Col className="sidebar">
            <div className="profile-section text-center">
              {/* Profile Picture Skeleton */}
              <div className="skeleton-circle profile-picture-skeleton"></div>
              {/* Name Skeleton */}
              <div className="skeleton-line name-skeleton"></div>
              {/* Email Skeleton */}
              <div className="skeleton-line email-skeleton"></div>
            </div>
            {/* Menu Items Skeleton */}
            <div className="menu-skeleton">
              <div className="skeleton-line menu-item-skeleton active-skeleton"></div>
              <div className="skeleton-line menu-item-skeleton"></div>
              <div className="skeleton-line menu-item-skeleton"></div>
            </div>
          </Col>
        </div>

        {/* Main Content Skeleton */}
        <Col md={6} className="main-content">
          <Container className="mt-4" style={{ maxWidth: "900px" }}>
            {/* Impressions Card Skeleton */}
            <Row>
              <Col>
                <Card className="p-3">
                  <div className="skeleton-line chart-title-skeleton"></div>
                  <Row className="align-items-center mb-3">
                    <Col className="d-flex align-items-center">
                      <div className="skeleton-line course-info-skeleton"></div>
                      <div className="skeleton-pill active-pill-skeleton"></div>
                    </Col>
                  </Row>
                  {/* Chart Area Skeleton */}
                  <div className="chart-skeleton">
                    <div className="chart-bars">
                      {[...Array(15)].map((_, index) => (
                        <div key={index} className="skeleton-bar" style={{ height: `${Math.random() * 60 + 20}%` }}></div>
                      ))}
                    </div>
                  </div>
                </Card>
              </Col>
            </Row>

            {/* Links List Card Skeleton */}
            <Row className="mt-4">
              <Col>
                <Card style={{ height: "400px" }}>
                  <Card.Body className="d-flex flex-column p-0">
                    {/* Search Input Skeleton */}
                    <div style={{ padding: "1rem" }}>
                      <div className="skeleton-line search-skeleton"></div>
                    </div>
                    {/* List Items Skeleton */}
                    <div style={{ flex: "1 1 auto", padding: "0 1rem" }}>
                      {[...Array(4)].map((_, index) => (
                        <div key={index} className="link-item-skeleton">
                          <div className="d-flex justify-content-between align-items-start mb-2">
                            <div>
                              <div className="skeleton-line link-title-skeleton"></div>
                              <div className="skeleton-line link-meta-skeleton"></div>
                            </div>
                            <div className="skeleton-circle delete-btn-skeleton"></div>
                          </div>
                          <div className="skeleton-line link-caption-skeleton"></div>
                          <div className="skeleton-line link-id-skeleton"></div>
                        </div>
                      ))}
                    </div>
                  </Card.Body>
                </Card>
              </Col>
            </Row>
          </Container>
        </Col>

        {/* Analytics Panel Skeleton */}
        <Col md={3} className="analytics-panel">
          <Container>
            <Row>
              <Col>
                <Card className="p-3">
                  <div className="skeleton-line analytics-title-skeleton"></div>
                  <div className="analytics-items">
                    {[...Array(5)].map((_, index) => (
                      <div key={index} className="analytics-item-skeleton">
                        <div className="d-flex justify-content-between align-items-center mb-2">
                          <div className="skeleton-line analytics-label-skeleton"></div>
                          <div className="skeleton-line analytics-value-skeleton"></div>
                        </div>
                        <div className="skeleton-progress-bar"></div>
                      </div>
                    ))}
                  </div>
                  <div className="skeleton-button see-all-btn-skeleton"></div>
                </Card>
              </Col>
            </Row>
          </Container>
        </Col>
      </Row>

      {/* Loading Animation Overlay */}
      <div className="loading-overlay">
        <div className="loading-spinner-container">
          <div className="loading-spinner"></div>
          <div className="loading-text">
            <span>Loading your dashboard</span>
            <div className="loading-dots">
              <span></span>
              <span></span>
              <span></span>
            </div>
          </div>
        </div>
      </div>
    </Container>
  );
};

export default DashboardLoading;
